import React from 'react';
import {
    Alert,
    Box,
    Button,

    Dialog,
    DialogContent,
    DialogTitle,

    Divider,

    Grid,

    TextField,

    Typography
} from "@mui/material";
import BarcodeScannerComponent from 'react-qr-barcode-scanner';
import {
    Notification,
    notificationTypes
} from "../../../../../common/Notification";
import {
    withStyles
} from "@mui/styles";
import {
    JsBarCodeScanner
} from "../../../../../components";
import { QrReader } from "react-qr-reader";


const initForm = {
    code: '',
    info: "",
};

const DEFAULT_ERROR_MESSAGE = 'Произошла непредвиденная ошибка. Попробуйте ещё раз.';

class DialogBarcodeReader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            form: {...initForm},
            isOpen: false,
            stopStream: true,
            cameraPermissionMessage: null,
        };
        this.scannerKey = 0; // Ключ для принудительного пересоздания сканера при необходимости
    }

    showError = (message = DEFAULT_ERROR_MESSAGE) => {
        try {
            Notification({
                message: typeof message === 'string' ? message : DEFAULT_ERROR_MESSAGE,
                type: notificationTypes.error,
            });
        } catch (e) {
            console.error('[DialogBarcodeReader] showError failed:', e);
        }
    };

    open = ({onSubmit} = {}) => {
        try {
            this.setState({
                onSubmit,
                isOpen: true,
            });
        } catch (e) {
            console.error('[DialogBarcodeReader] open failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    close = () => {
        try {
            // Принудительно останавливаем сканер перед закрытием
            this.setState({
                form: {...initForm},
                isOpen: false,
                stopStream: true,
                cameraPermissionMessage: null,
            });
            // Увеличиваем ключ для полного пересоздания сканера при следующем открытии
            this.scannerKey += 1;
        } catch (e) {
            console.error('[DialogBarcodeReader] close failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    changeForm = (ev) => {
        try {
            const target = ev?.target;
            if (!target || typeof target.name === 'undefined') return;
            const {name, value} = target;
            const form = {...(this.state.form || initForm)};
            form[name] = value;
            this.setState({form});
        } catch (e) {
            console.error('[DialogBarcodeReader] changeForm failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    create = async () => {
        try {
            const error = this.checkValidation();
            if (error) {
                this.showError(error);
                return;
            }
            const {onSubmit} = this.state;
            if (typeof onSubmit !== 'function') {
                this.showError('Ошибка: действие создания недоступно.');
                return;
            }
            onSubmit(this.state.form);
        } catch (e) {
            console.error('[DialogBarcodeReader] create failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    checkValidation = () => {
        try {
            const form = this.state?.form ?? initForm;
            const errors = [];
            if (!form?.code) {
                errors.push('Отсканируйте штрих-код или введите вручную');
            }
            return errors.length ? errors.join(';<br/>') : '';
        } catch (e) {
            console.error('[DialogBarcodeReader] checkValidation failed:', e);
            return DEFAULT_ERROR_MESSAGE;
        }
    };

    onUpdate = async (err, result) => {
        try {
            const form = {...(this.state.form || initForm)};
            if (result?.text) {
                form.code = result.text;
                this.setState({form, stopStream: true});
                const onCheck = this.props?.onCheckOrderByBarcode;
                if (typeof onCheck === 'function' && (await onCheck(result.text))) {
                    return null;
                }
            } else {
                form.code = '';
                this.setState({form, stopStream: false});
            }
        } catch (e) {
            console.error('[DialogBarcodeReader] onUpdate failed:', e);
            this.setState({stopStream: true});
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    onError = (error) => {
        try {
            this.setState({stopStream: true});
            const message = error?.message ?? (typeof error === 'string' ? error : 'Ошибка сканера');
            this.showError(message);
        } catch (e) {
            console.error('[DialogBarcodeReader] onError failed:', e);
        }
    };

    onSuccessScan = async (code) => {
        try {
            if (code == null || String(code).trim() === '') return;
            const form = {...(this.state.form || initForm)};
            form.code = String(code);
            // Останавливаем сканер сразу после успешного сканирования
            this.setState({form, stopStream: true});
            const onCheck = this.props?.onCheckOrderByBarcode;
            if (typeof onCheck === 'function' && (await onCheck(code, true, true)) === true) {
                return null;
            }
        } catch (e) {
            console.error('[DialogBarcodeReader] onSuccessScan failed:', e);
            this.setState({stopStream: true});
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    setStopStream = (stopStream) => {
        try {
            const shouldStop = Boolean(stopStream);
            // При запуске сканирования увеличиваем ключ для полного пересоздания компонента
            if (!shouldStop) {
                this.scannerKey += 1;
            }
            this.setState({
                stopStream: shouldStop,
                ...(shouldStop ? { cameraPermissionMessage: null } : {}),
            });
        } catch (e) {
            console.error('[DialogBarcodeReader] setStopStream failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    handleCloseStopStream = () => {
        try {
            this.setStopStream(true);
        } catch (e) {
            console.error('[DialogBarcodeReader] handleCloseStopStream failed:', e);
            this.showError(DEFAULT_ERROR_MESSAGE);
        }
    };

    onCameraError = (message) => {
        try {
            this.setState({
                cameraPermissionMessage: message || null,
                stopStream: true,
            });
        } catch (e) {
            console.error('[DialogBarcodeReader] onCameraError failed:', e);
        }
    };

    render() {
        try {
            const {form = initForm, isOpen, stopStream, cameraPermissionMessage} = this.state ?? {};
            const {classes = {}} = this.props ?? {};
            return (
            <Dialog
                fullWidth
                maxWidth="md"
                scroll="body"
                open={isOpen}
                onClose={this.close}
            >
                <DialogTitle>
                    <Typography variant="h3">
                        Создание услуги (штрих-код)
                    </Typography>
                    <Typography variant="h6" textAlign="center">
                        Отсканируйте штрих-код или введите вручную
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Divider className={classes?.divider} sx={{marginTop: "0!important"}}/>

                    {cameraPermissionMessage && (
                        <Alert severity="warning" sx={{ mb: 2 }}>
                            {cameraPermissionMessage}
                        </Alert>
                    )}

                    {stopStream && (
                        <Button
                            fullWidth
                            size="large"
                            variant='contained'

                            onClick={this.setStopStream.bind(this, false)}
                        >
                            Сканировать
                        </Button>
                    )}

                    {!stopStream && (
                        <>
                            <JsBarCodeScanner
                              key={this.scannerKey}
                              onSuccess={this.onSuccessScan}
                              onResult={this.onSuccessScan}
                              onCancel={this.setStopStream.bind(this, true)}
                              onError={this.onCameraError}
                            />
                            <Box mt={2}></Box>
                            <Button
                                fullWidth
                                size="large"
                                variant='outlined'

                                onClick={this.handleCloseStopStream}
                            >
                                Отменить сканирование
                            </Button>
                        </>
                    )}

                    <Divider className={classes?.divider}/>

                    <TextField
                        value={form.code}
                        name="code"
                        label="Код"
                        placeholder="Введите код"
                        variant="outlined"
                        size="small"
                        fullWidth
                        disabled={!stopStream}
                        onChange={this.changeForm}
                    />

                    <Divider className={classes?.divider}/>

                    <Grid container justifyContent="flex-end" spacing={1}>
                        <Grid item>
                            <Button variant="outlined" size="small" onClick={this.close}>Закрыть</Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" size="small" onClick={this.create}>Создать</Button>
                        </Grid>
                    </Grid>

                </DialogContent>
            </Dialog>
            );
        } catch (e) {
            console.error('[DialogBarcodeReader] render failed:', e);
            return null;
        }
    }
}

const styles = {
    divider: {
        margin: "24px -24px",
        "@media(max-width: 1199px)": {
            margin: "12px -8px",
        }
    }
};

export default withStyles(styles)(DialogBarcodeReader);
